<template>
  <div>
    <v-card
        class="mb-1"
    >
        <v-dialog v-model="dialogDocumentSign" max-width="500px">
            <v-card>
                <v-card-title>
                    <span class="headline">{{ $t(`enrollments.doc_uploaded`) }}</span>
                </v-card-title>

                <v-card-text>
                    <object :data="'data:application/pdf;base64,' + documentSigned" type="application/pdf" width="460px" height="500px"></object>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat @click="dialogDocumentSign = false">{{ $t(`enrollments.cancel`) }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-layout row wrap justify-center align-center v-for="(item, index) in family_info" :key="index">
          <v-flex mt-2 pl-3 xs2 sm3 md2>
            <v-avatar color="indigo">
                <v-icon dark>account_circle</v-icon>
            </v-avatar>
          </v-flex>
          <v-flex mt-2 class="text-xs-center" xs12 sm5 md3>
            <strong>{{ item.full_name }}</strong>
          </v-flex>
          <v-flex mt-2 xs12 sm4 md7 class="pl-4 text-xs-center">
            <v-btn v-if="!item['360_document_status']" color="primary" @click="showDialogDitialSign(item.id)">{{ $t(`admissions.sign_book`) }}</v-btn>
            <v-btn v-else-if="item['360_document_status'] === 'P'" color="accent" @click="continueVistaSign(item['360_document_id'], item.id)">{{ $t(`enrollments.continue_sign_book`) }}</v-btn>
            <v-btn v-else="item['360_document_status'] === 'F'" color="success" @click="showVistaFile(item['360_document_id'], item.id)">{{ $t(`enrollments.see_document`) }}</v-btn>
          </v-flex>
        </v-layout>
    </v-card>
    <v-layout row justify-center>
      <v-btn flat @click="goToPrevStep">{{ $t(`enrollments.back`) }}</v-btn>
      <v-btn v-if="document_status" @click="goToNextStep" color="primary">{{ $t(`enrollments.next`) }}</v-btn>
    </v-layout>
    <v-dialog v-model="dialogDigitalSign" fullscreen>
      <digital-sign-comp
        v-on:closeDialog="closeSignDialog"
        :studentId="document_process_id || ''"
        :documentId="documentSignId"
        :action="vista_action"
        :processId="document_process_id"
        :recordId="vista_record_id"
      ></digital-sign-comp>
  </v-dialog>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import axios from 'axios'
  import Form from 'vform'
  import DigitalSignComponent from './digital_sign'
  export default {
    name: 'admissions-step2',
    components: {
      'digital-sign-comp': DigitalSignComponent,
    },
    props: {
      family: {
        type: [Array],
        required: true
      },
      settings: {
        type: [Object],
        required: true
      }
    },
    data() {
      return {
        dialogDigitalSign: false,
        dialogDocumentSign: false,
        documentSigned: '',
        document: null,
        document_process_id: 0,
        documentSignId: '4100',
        vista_action: '',
        vista_record_id: '',
        document_id: null,
        family_info: [],
        document_status: false,
      }
    },
    created () {
      this.init()
    },
    watch: {
      dialogDigitalSign(newValue, oldValue) {
        if (oldValue && !newValue) {
          this.documentSignId = this.settings.document_id
          this.vista_action = ''
          this.document_process_id = ''
          this.vista_record_id = ''
        }
      }
    },
    methods: {
      async init() {
        this.family_info = this.family
        this.documentSignId = this.settings.document_id
        this.document_status = this.setStatus()
      },
      setStatus() {
        const students = this.family_info.filter(student => student['360_document_status'] != "F")
        if (students.length > 0) {
          console.log(students.length)
          return false
        }
        console.log(students.length)
        return true
      },
      showDialogDitialSign(id) {
       const payload = {
          id: id,
          "360_document_status": "P"
        }
        this.vista_action = 'CREATE'
        axios.put('/api/admissions/entries', payload)
          .then(resp => {
            if (resp.status === 200) {
              this.document_process_id = resp.data.entry_id
              this.dialogDigitalSign = true
            }
          })
          .catch(err => console.log(err))
      },
      showVistaFile(file, id) {
        this.vista_action = 'SHOW'
        this.vista_record_id = file
        this.dialogDigitalSign = true
      },
      continueVistaSign(file, id) {
        this.vista_action = 'CREATE'
        if (!file && file > 0) {
          this.vista_action = 'UPDATE'
        }
        this.document_process_id = id
        this.vista_record_id = file
        this.dialogDigitalSign = true
      },
      closeSignDialog() {
        axios.get('/api/admissions/get_admissions_info')
          .then(resp => {
            if (resp.status === 200) {
              this.family_info = resp.data
              this.document_status = this.setStatus()
            }
          })
          .catch(error => console.log(error))
        this.dialogDigitalSign = false
      },
      async goToNextStep() {
        await this.updateStep()
        this.$emit('goToNextStep', 3, this.family_info)
      },
      goToPrevStep() {
        this.$emit('goToPrevStep', 1)
      },
      async updateStep() {
        const payload = {
          entry_id : this.family_info[0].id,
          step : 3
        }
        await axios.put('/api/admissions/update_step', payload)
          .then(resp => {
            if (resp.status === 200) {
              this.family_info[0] = resp.data.updated
            }
          })
      },
    },
  }
</script>



// WEBPACK FOOTER //
// resources/assets/js/pages/admissions/admissions_step2.vue